import styled from "styled-components";

interface CoverageInfoProps {
  dynamicInsuranceDetailsCard?: boolean;
  selected?: boolean;
}

export const CoverageInfo = styled.div<CoverageInfoProps>`
  & p {
    line-height: 16px;
    margin-right: 8px;
  }

  & button {
    color: ${({ theme }) => theme.insuranceDetailsCard.buttonColor};

    svg {
      path {
        fill: ${({ theme }) => theme.insuranceDetailsCard.buttonColor};
      }

      margin-left: 8px;
    }
  }
`;

export const StyledComparisonWrap = styled.div`
  margin-top: 50px;
`;
